import React from 'react';
import { Loader, BaasicTable, BaasicHeader } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const SellerListTemplate = ({
	t,
	viewStore,
	viewStore: { listStore, tableData, queryUtility },
	headerCell,
	actions,
}) => {
	if (viewStore.loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.ADMINISTRATION.SELLERS"></BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
					headerCell,
					actions,
				}}
				data={listStore.data.slice()}
			/>
		</section>
	);
};

export default defaultTemplate(SellerListTemplate);
